// extracted by mini-css-extract-plugin
export default {"editButton":"styles_editButton__mSR1G","searchInput":"styles_searchInput__9iH7Q"};